/*
 * Handles dialog and confirmation windows
 */

define([
  "marionette",
  "backbone",
  "underscore",
  "messaging/messenger",
  "modules/dialogWindow/dialogWindowView",
], function (Marionette, Backbone, _, Messenger, DialogWindowView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "dialogWindow";
      this.region = options.region;
      this._setUpVents();
      this._setUpReqres();
    },
    show: function ({
      message,
      callbacks = {},
      context = null,
      confirmI18NKey = "common.ok",
      showComment = false,
    } = {}) {
      if (!context) {
        context = this; //set the context to this module if no context is provided
      }
      //save any textboxes, if possible
      Messenger.reqres.request("save:textbox");

      const model = new Backbone.Model({
        message: _.isArray(message) ? message : [message],
        comment: "",
        yes: typeof callbacks.yes !== "undefined",
        no: typeof callbacks.no !== "undefined",
        cancel: typeof callbacks.cancel !== "undefined",
        ok: typeof callbacks.ok !== "undefined",
        confirm: typeof callbacks.confirm !== "undefined",
        confirmKey: confirmI18NKey,
        showComment: showComment,
      });
      this.view = new DialogWindowView.dialogWindowView({ model: model });
      this.region.backdrop = "static";
      //for each button click event, make sure that we close the dialog window before calling
      //the callback, in case the callback triggers another dialog window.
      this.view.on(
        "click:yes",
        function () {
          this.view.on("close", function () {
            callbacks.yes.call(context);
          });
          this._closeModal();
        },
        this,
      );
      this.view.on(
        "click:no",
        function () {
          this.view.on("close", function () {
            callbacks.no.call(context);
          });
          this._closeModal();
        },
        this,
      );
      this.view.on(
        "click:cancel",
        function () {
          this.view.on("close", function () {
            callbacks.cancel.call(context);
          });
          this._closeModal();
        },
        this,
      );
      this.view.on(
        "click:ok",
        function () {
          this.view.on("close", function () {
            callbacks.ok.call(context);
          });
          this._closeModal();
        },
        this,
      );
      this.view.on(
        "click:confirm",
        function () {
          this.view.on("close", function () {
            if (model.get("showComment")) {
              callbacks.confirm.call(context, model.get("comment"));
            } else {
              callbacks.confirm.call(context);
            }
          });
          this._closeModal();
        },
        this,
      );
      this.showRegion(this.view);
    },
    _closeModal: function () {
      this.region.$el.modal("hide");
    },
    _setUpReqres: function () {
      //check whether the dialog window is open
      Messenger.reqres.setHandler(
        "dialog:window:open",
        function () {
          return this.isOpen;
        },
        this,
      );
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:dialog:window",
        function (options = {}) {
          this.show(options);
        },
        this,
      );
    },
  });
});
